import { IPromise } from 'angular';

import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { DeleteExtractTasksRequest } from '../../ts/ServerApi/requests/DeleteExtractTasksRequest';
import { GetExtractTasksRequest } from '../../ts/ServerApi/requests/GetExtractTasksRequest';
import { ResumeExtractTasksRequest } from '../../ts/ServerApi/requests/ResumeExtractTasksRequest';
import { RunExtractTasksRequest } from '../../ts/ServerApi/requests/RunExtractTasksRequest';
import { SetExtractTasksPriorityRequest } from '../../ts/ServerApi/requests/SetExtractTasksPriorityRequest';
import { SetExtractTasksScheduleRequest } from '../../ts/ServerApi/requests/SetExtractTasksScheduleRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToast, WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { ServiceLocator } from '../../app/ServiceLocator';

export class ExtractTasksResource {

  private fetcher = new WebClientListResourceFetcher(GetExtractTasksRequest,ServerApiMapper.extractTasks);

  public MAX_PRIORITY = 100;
  public MIN_PRIORITY = 1;

  public del(ids: string[]): IPromise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteExtractTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public all(): ResourceQuery<IExtractTaskInfo> {
    return new ResourceQuery(this.fetcher);
  }

  public run(ids: string[]): IPromise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new RunExtractTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public resume(ids: string[]): IPromise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new ResumeExtractTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public setPriority(ids: string[], priority: number): IPromise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetExtractTasksPriorityRequest(idsBlock, priority)),
      ResultHelper.combineResults);
  }

  public setSchedule(ids: string[], scheduleId: string) {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetExtractTasksScheduleRequest(idsBlock, scheduleId)),
      ResultHelper.combineResults);
  }

  public getErrorNotifyingServer(): WebHttpClientWithErrorToast {
    return WebHttpClientWithErrorToastInstance;
  }

}
  export const ExtractTasks = new ExtractTasksResource();
